import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteAlertasUsuariosEncaminhados } from "./services";

const initialState = {
  data: [],
  status: "idle",
  error: null,
};

export const actionDeleteAlertasUsuariosEncaminhados = createAsyncThunk(
  "ACTION_DELETE_ALERTA_USUARIOS_ENCAMINHADOS",
  async ({
    nomeUsuario,
    idLoja,
    idCliente,
  }: {
    nomeUsuario: string;
    idLoja: number;
    idCliente: number;
  }) => {
    return deleteAlertasUsuariosEncaminhados(nomeUsuario, idLoja, idCliente);
  },
);

const sliceDeleteAlertasUsuariosEncaminhados = createSlice({
  name: "DELETE_ALERTA_USUARIOS_ENCAMINHADOS",
  initialState,
  reducers: {
    actionResetDeleteAlertasUsuariosEncaminhados: (state) => {
      state.status = "";
      state.data = [];
    },
  },
  extraReducers: {
    [`${actionDeleteAlertasUsuariosEncaminhados.pending}`]: (state) => {
      state.status = "loading";
    },
    [`${actionDeleteAlertasUsuariosEncaminhados.fulfilled}`]: (
      state,
      { payload },
    ) => {
      state.status = "success";
      state.data = payload;
    },
    [`${actionDeleteAlertasUsuariosEncaminhados.rejected}`]: (state) => {
      state.status = "error";
    },
  },
});

export default sliceDeleteAlertasUsuariosEncaminhados.reducer;
export const { actionResetDeleteAlertasUsuariosEncaminhados } =
  sliceDeleteAlertasUsuariosEncaminhados.actions;
